// extracted by mini-css-extract-plugin
export default {"Outer":"ChangeCta_Outer__cnX5c"};